import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE_LSET',
  CREATE: 'CREATE_ZONE_LSET',
  EDIT: 'EDIT_ZONE_LSET',
  DELETE: 'DELETE_ZONE_LSET',
};

export const searchLightingSetInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  const zoneParams = zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_LT_SET,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listLightingSetInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  return {
    type: ACTION.LIST,
    payload: searchLightingSetInZone(pageSize, page, sorted, filtered, isPublic, zoneId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addLightingSetToZone = (ahuId, zoneId, quantity) => {
  const formData = new FormData();
  formData.set('lighting_set_id', ahuId);
  formData.set('zone_id', zoneId);
  formData.set('quantity', quantity);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_LT_SET,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editLightingSetInZone = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE_LT_SET}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeLightingSetFromZone = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ZONE_LT_SET}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_lt_set_actions.js